import { loadStripe } from "@stripe/stripe-js";
import { config } from "../config";
import { planPrice } from "../utils/helperFuntions";
import { useUser } from "./use-user";

// Load your publishable key from Stripe
const stripePromise = loadStripe(
  `${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`,
);

export const useStudentPlan = () => {
  const user = useUser();
  const API_URL = config.baseUrl.default;

  // Starts Stripe Checkout for a plan of `days` days.
  // Resolves when the browser is redirecting; throws a readable error otherwise.
  const checkout = async (days: number) => {
    if (!user?.id) {
      throw new Error("Please sign in again to purchase a plan.");
    }

    const stripe = await stripePromise;
    if (!stripe) {
      throw new Error(
        "Payments are unavailable right now. Please try again later.",
      );
    }

    const response = await fetch(`${API_URL}student-subscription-payment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        days,
        totalPrice: planPrice(days),
        userId: user.id,
      }),
    });
    const session = await response.json().catch(() => null);
    if (!response.ok || !session?.id) {
      throw new Error("We couldn't start the checkout. Please try again.");
    }

    // Redirect to Stripe Checkout
    const result = await stripe.redirectToCheckout({ sessionId: session.id });
    if (result?.error) {
      throw new Error(
        result.error.message ?? "Checkout failed. Please try again.",
      );
    }
  };

  return { checkout };
};
